<div id="t4dapp" [class.in-frame]="in_frame">

  <!-- host selection screen -->
  <app-idtag *ngIf="!idtag" (validTag)="setTag($event)"></app-idtag>

  <!-- loading screen -->
  <loading-indicator *ngIf="loading|async"></loading-indicator>

  <!-- the actual app, visible when idtag is set and host is loaded -->
  <router-outlet *ngIf="idtag && host"></router-outlet>

</div>
